<div class="featured-image-block d-flex flex-column h-100" *ngIf="config && config.ImageUrl">
    <div class="featured-image-block-image-wrapper overflow-hidden" [class.flex-fill]="stretch">
        <img class="featured-image-block-image w-100" [class.h-100]="stretch" [src]="config.ImageUrl" alt="" />
    </div>
    <div class="featured-image-block-caption" *ngIf="config.Caption" [innerHTML]="config.Caption | keepHtml"></div>
</div>
